import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import axios from "../axios";
import { saveGuestScan } from "../utils/guestStorage";
import { useNavigate } from "react-router-dom";

const QrScanner = () => {
  const navigate = useNavigate();
  const qrRef = useRef(null);

  useEffect(() => {
  let html5QrCode;

  const startScanner = async () => {
    try {
      // ⏳ petit délai pour laisser React monter le DOM (clé pour mobile)
      await new Promise((res) => setTimeout(res, 300));

      if (!qrRef.current) return;

      html5QrCode = new Html5Qrcode(qrRef.current.id);

      await html5QrCode.start(
        { facingMode: { exact: "environment" } }, // 🔥 plus fiable mobile
        {
          fps: 10,
          qrbox: (w, h) => {
            const size = Math.min(w, h) * 0.7;
            return { width: size, height: size };
          },
        },
        (decodedText) => {
          html5QrCode.stop();
          handleScan(decodedText);
        }
      );
    } catch (err) {
  console.error("❌ Erreur caméra :", err);
  alert(err.message);
    }
  };

  startScanner();

  return () => {
    if (html5QrCode) {
      html5QrCode.stop().catch(() => {});
    }
  };
}, []);

  const handleScan = async (decodedText) => {
    try {
      const getLocation = () =>
        new Promise((resolve) => {
          if (!navigator.geolocation) return resolve(null);
          navigator.geolocation.getCurrentPosition(
            (pos) =>
              resolve({
                lat: pos.coords.latitude,
                lng: pos.coords.longitude,
              }),
            () => resolve(null),
            { timeout: 3000 }
          );
        });

      const location = await getLocation();

      await axios.post("/scans", {
        productId: decodedText,
        userId: "guest",
        location,
      });

      const response = await axios.get(`/products/scan/${decodedText}`);
      const product = response.data;

      saveGuestScan({
        id: product._id,
        name: product.name,
        location,
      });

      navigate(`/products/${product._id}`);
    } catch (error) {
      console.error("Erreur scan invité :", error);
    }
  };

  return (
    <div
      id="reader"
      ref={qrRef}
      style={{ width: "100%", minHeight: "300px" }}
    />
  );
};

export default QrScanner;
